import React, { useState } from 'react'
import TableLoader from '../../common/TableLoader'
import PageHeader from '../../shared/PageHeader'
import { useTranslation } from 'react-i18next'
import CustomButton from '../../shared/CustomButton'
import PayerLevelTable from './PayerLevelTable'

function NprPayerLevel () {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  return (
    <div>
      {loading ? (
        <TableLoader />
      ) : (
        <div className='superGit_container !p-0'>
          <PageHeader
            title={t('Payer Level')}
            subtitle
            total={0}
            entriesLabel={t('Entries')}
          >
            {/* <CustomButton
              label={t('Add New Payer')}
              icon={<AddIcon />}
              onClick={() => {
                navigate('/payer-managment/form')
              }}
            /> */}
          </PageHeader>
          <div className='mt-3'>
            <PayerLevelTable />
          </div>
        </div>
      )}
    </div>
  )
}

export default NprPayerLevel
